import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { Constants } from "../interfaces/constants";
import { CirculationDetailsComponent } from "./details/circulation-details.component";
import {
  CirculationFormEditComponent,
  CirculationFormNewComponent
} from "./form";
import { ListShellComponent } from "./list/list-shell/list-shell.component";
import { NewFromPreparedComponent } from "./new-from-prepared/new-from-prepared.component";
import { NewFromTemplateComponent } from "./new-from-template/new-from-template.component";
import { ReorderStepsComponent } from "./reorder-steps/reorder-steps.component";
import { StartMultipleCirculationsComponent } from "./start-multiple/start-multiple.component";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: "circ",
    children: [
      { path: "", pathMatch: "full", component: ListShellComponent },
      { path: "new", component: CirculationFormNewComponent },
      { path: "newFromTemplate", component: NewFromTemplateComponent },
      { path: "startMultiple", component: StartMultipleCirculationsComponent },
      {
        path: `newFromPrepared/:${Constants.routeParams.prepareId}`,
        component: NewFromPreparedComponent
      },
      {
        path: `id/:${Constants.routeParams.circId}`,
        children: [
          {
            path: "",
            pathMatch: "full",
            component: CirculationDetailsComponent
          },
          {
            path: "reorderSteps",
            component: ReorderStepsComponent
          },
          {
            path: "edit",
            component: CirculationFormEditComponent
          }
        ]
      }
    ],
    canActivate: [MsalGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CirculationsRoutingModule { }
